export const allRouter = [
  // {
  //   path: '/coupon/centerInfo',
  //   name: 'centerInfo',
  //   meta: {
  //     name: '信息中心',
  //     keepAlive: false
  //   },
  //   redirect: '/coupon/centerInfo/info',
  //   component: () => import('@/components/index.vue'),
  //   children: [
  //     {
  //       path: '/coupon/centerInfo/info',
  //       meta: {
  //         name: '信息中心',
  //         keepAlive: false
  //       },
  //       component: () => import('@/views/coupon/centerInfo/centerInfo.vue')
  //     }
  //   ]
  // },
  // {
  //   path: '/coupon/signData',
  //   name: 'signData',
  //   meta: {
  //     name: '签名校验工具',
  //     keepAlive: false
  //   },
  //   redirect: '/coupon/signData/signDataQuery',
  //   component: () => import('@/components/index.vue'),
  //   children: [
  //     {
  //       path: '/coupon/signData/signDataQuery',
  //       meta: {
  //         name: '签名校验工具',
  //         keepAlive: false
  //       },
  //       component: () => import('@/views/coupon/signData/signDataQuery.vue')
  //     }
  //   ]
  // },
  {
    path: '/home',
    name: 'homePage',
    component: () => import('@/views/home.vue'),
    meta: {
      keepAlive: false,
      isBlank: false
    }
  },
  {
    path: '/sys/declareDateSet',
    name: 'declareDateSet',
    meta: {
      name: '集中申报期窗口设置'
    },
    redirect: '/sys/declareDateSet/index',
    component: () => import('@/components/index.vue'),
    children: [
      {
        path: '/sys/declareDateSet/index',
        meta: {
          name: '集中申报期窗口设置'
        },
        component: () => import('@/views/system/declareDateSet/index.vue')
      }
    ]
  },
  {
    path: '/sys/linXuanChannel',
    name: 'linXuanChannel',
    meta: {
      name: '遴选渠道管理'
    },
    redirect: '/sys/linXuanChannel/list',
    component: () => import('@/components/index.vue'),
    children: [
      {
        path: '/sys/linXuanChannel/channelList',
        meta: {
          name: '渠道申报列表'
        },
        component: () => import('@/views/system/linXuanChannel/channelList.vue')
      },
      {
        path: '/sys/linXuanChannel/list',
        meta: {
          name: '渠道审核列表'
        },
        component: () => import('@/views/system/linXuanChannel/list.vue')
      },
      {
        path: '/sys/linXuanChannel/channelQuery',
        meta: {
          name: '渠道查询'
        },
        component: () => import('@/views/system/linXuanChannel/channelQuery.vue')
      },
      {
        path: '/sys/linXuanChannel/channelIndex/:operator/:wfType/:flowState/:channelId',
        name: '/sys/linXuanChannel/channelIndex',
        meta: {
          name: '渠道申报'
        },
        component: () => import('@/views/system/linXuanChannel/channelIndex.vue')
      },
      {
        path: '/sys/linXuanChannel/channelView/:operator/:wfType/:flowState/:flowId',
        name: '/sys/linXuanChannel/channelView',
        meta: {
          name: '渠道申报'
        },
        component: () => import('@/views/system/linXuanChannel/channelView.vue')
      },
      {
        path: '/sys/linXuanChannel/channelAudit/:declareType/:operator',
        name: '/sys/linXuanChannel/channelAudit',
        meta: {
          name: '渠道审核'
        },
        component: () => import('@/views/system/linXuanChannel/channelAudit.vue')
      },
      {
        path: '/sys/linXuanChannel/channelPay/:operator/:wfType/:flowState/:channelId/:isAdd',
        name: '/sys/linXuanChannel/channelPay',
        meta: {
          name: '支付许可证修改'
        },
        component: () => import('@/views/system/linXuanChannel/channelPay.vue')
      },
      {
        path: '/sys/linXuanChannel/merchantIndex/:operator/:wfType/:flowState/:channelId',
        name: '/sys/linXuanChannel/merchantIndex',
        meta: {
          name: '新增商户/门店'
        },
        component: () => import('@/views/system/linXuanChannel/merchantIndex.vue')
      },
      {
        path: '/sys/linXuanChannel/merchantView/:operator/:wfType/:flowState/:flowId',
        name: '/sys/linXuanChannel/merchantView',
        meta: {
          name: '新增商户/门店'
        },
        component: () => import('@/views/system/linXuanChannel/merchantView.vue')
      },
      {
        path: '/sys/linXuanChannel/merchantAudit/:declareType/:operator',
        name: '/sys/linXuanChannel/merchantAudit',
        meta: {
          name: '商户审核'
        },
        component: () => import('@/views/system/linXuanChannel/merchantAudit.vue')
      },{
        path: '/sys/linXuanChannel/merchantStoreIndex/:declareType/:operator',
        name: '/sys/linXuanChannel/merchantStoreIndex',
        meta: {
          name: '门店申报'
        },
        component: () => import('@/views/system/linXuanChannel/merchantStoreIndex.vue')
      },{
        path: '/sys/linXuanChannel/merchantStoreAudit/:declareType/:operator',
        name: '/sys/linXuanChannel/merchantStoreAudit',
        meta: {
          name: '门店审核'
        },
        component: () => import('@/views/system/linXuanChannel/merchantStoreAudit.vue')
      },
      {
        path: '/sys/linXuanChannel/edit',
        name: '/sys/linXuanChannel/edit',
        meta: {
          name: '渠道申报列表'
        },
        component: () => import('@/views/system/linXuanChannel/edit.vue')
      },
      {
        path: '/sys/linXuanChannel/audit',
        name: '/sys/linXuanChannel/audit',
        meta: {
          name: '渠道申报列表'
        },
        component: () => import('@/views/system/linXuanChannel/merchantAudit.vue')
      }
    ]
  },
  {
    path: '/sys/merchant',
    name: 'merchant',
    meta: {
      name: '商户管理'
    },
    redirect: '/sys/merchant/merchantList',
    component: () => import('@/components/index.vue'),
    children: [
      {
        path: '/sys/merchant/merchantList',
        meta: {
          name: '商户列表'
        },
        component: () => import('@/views/system/merchant/list.vue')
      },
      {
        path: '/sys/merchant/view/:flowId',
        name: 'merchantView',
        meta: {
          name: '商户详情'
        },
        component: () => import('@/views/system/merchant/view.vue')
      },
      {
        path: '/sys/merchant/storeList/:channelId/:merchantId',
        name: 'merchantStoreList',
        meta: {
          name: '门店列表'
        },
        component: () => import('@/views/system/merchant/storeList.vue')
      },
      {
        path: '/sys/merchant/storeDetail/:channelId/:merchantId/:storeId',
        name: 'storeDetail',
        meta: {
          name: '门店详情'
        },
        component: () => import('@/views/system/merchant/storeDetail.vue')
      }
    ]
  },
  {
    path: '/sys/channel',
    name: 'channel',
    meta: {
      name: '渠道信息'
    },
    redirect: '/sys/channel/index',
    component: () => import('@/components/index.vue'),
    children: [
      {
        path: '/sys/channel/index',
        name: 'channelBasicInfo',
        meta: {
          name: '渠道基本信息'
        },
        component: () => import('@/views/system/channel/index.vue')
      }
    ]
  },
  {
    path: '/sys/workflow',
    name: 'workflow',
    meta: {
      name: '当月流程'
    },
    redirect: '/sys/workflow/workflowList',
    component: () => import('@/components/index.vue'),
    children: [
      {
        path: '/sys/workflow/workflowList',
        meta: {
          name: '流程列表'
        },
        component: () => import('@/views/system/workflow/list.vue')
      },
      {
        path: '/sys/workflow/view/:id',
        name: 'workflowView',
        meta: {
          name: '流程详情'
        },
        component: () => import('@/views/system/workflow/view.vue')
      },
      {
        path: '/sys/workflow/merchantList/:flowId',
        name: 'workflowMerchantList',
        meta: {
          name: '商户列表'
        },
        component: () => import('@/views/system/workflow/merchantList.vue')
      },
      {
        path: '/sys/workflow/storeList/:flowId',
        name: 'workflowStoreList',
        meta: {
          name: '门店列表'
        },
        component: () => import('@/views/system/workflow/storeList.vue')
      },
      {
        path: '/sys/workflow/storeDetail/:flowId/:storeId',
        name: 'workflowStoreDetail',
        meta: {
          name: '门店详情'
        },
        component: () => import('@/views/system/workflow/storeDetail.vue')
      },
      {
        path: '/sys/workflow/merchantDetail/:flowId/:merchantId',
        name: 'workflowMerchantDetail',
        meta: {
          name: '商户详情'
        },
        component: () => import('@/views/system/workflow/merchantDetail.vue')
      },
      {
        path: '/sys/workflow/channelDialog/:wfType/:operator/:flowState',
        name: 'workflowChannelDialog',
        meta: {
          name: '渠道申报'
        },
        component: () => import('@/views/system/workflow/channelDialog.vue')
      },
      {
        path: '/sys/workflow/merchantDialog/:wfType/:operator/:flowState',
        name: 'workflowMerchantDialog',
        meta: {
          name: '商户门店申报'
        },
        component: () => import('@/views/system/workflow/merchantDialog.vue')
      }
    ]
  },
  {
    path: '/sys/workflowHistory',
    name: 'workflowHistory',
    meta: {
      name: '历史流程'
    },
    redirect: '/sys/workflowHistory/workflowList',
    component: () => import('@/components/index.vue'),
    children: [
      {
        path: '/sys/workflowHistory/workflowList',
        meta: {
          name: '流程列表'
        },
        component: () => import('@/views/system/workflowHistory/list.vue')
      },
      {
        path: '/sys/workflowHistory/view/:id',
        name: 'workflowHistoryView',
        meta: {
          name: '流程详情'
        },
        component: () => import('@/views/system/workflowHistory/view.vue')
      },
      {
        path: '/sys/workflow/merchantList/:flowId',
        name: 'workflowMerchantList',
        meta: {
          name: '商户列表'
        },
        component: () => import('@/views/system/workflow/merchantList.vue')
      },
      {
        path: '/sys/workflow/storeList/:flowId',
        name: 'workflowStoreList',
        meta: {
          name: '门店列表'
        },
        component: () => import('@/views/system/workflow/storeList.vue')
      },
      {
        path: '/sys/workflow/storeDetail/:flowId/:storeId',
        name: 'workflowStoreDetail',
        meta: {
          name: '门店详情'
        },
        component: () => import('@/views/system/workflow/storeDetail.vue')
      },
      {
        path: '/sys/workflow/merchantDetail/:flowId/:merchantId',
        name: 'workflowMerchantDetail',
        meta: {
          name: '商户详情'
        },
        component: () => import('@/views/system/workflow/merchantDetail.vue')
      }
    ]
  },
  {
    path: '/sys/adminChannel',
    name: 'adminChannel',
    meta: {
      name: '渠道管理'
    },
    redirect: '/sys/adminChannel/list',
    component: () => import('@/components/index.vue'),
    children: [
      {
        path: '/sys/adminChannel/list',
        meta: {
          name: '渠道列表'
        },
        component: () => import('@/views/system/adminChannel/list.vue')
      },
      {
        path: '/sys/adminChannel/view/:channelId',
        meta: {
          name: '渠道详情'
        },
        component: () => import('@/views/system/adminChannel/view.vue')
      },
      {
        path: '/sys/adminChannel/workflowView',
        meta: {
          name: '流程/商户/门店'
        },
        component: () => import('@/views/system/adminChannel/workflowView.vue')
      }
    ]
  },
];
  